import React, { useEffect, useState } from 'react'
import SelectInput from '../Common/SelectInput'
import TextInput from '../Common/TextInput'
import TextArea from '../Common/TextArea'
import html2canvas from "html2canvas";
import {skeletonBadges} from './skeleton'
 
function Form({ formObj, setFormObj, formSubmitHandler, textAreaHandler, onChangeHandler }) {
  const {
    title,
    issuedBy,
    state,
    version,
    authorizedBy,
    type,
    level,
    time,
    expirationYears,
    criteria,
    description,
    skills,
    image,
  } = formObj

  useEffect(() => {
    // imagePicker.current.value = '' // used for uploading from client side
    setImageSrc({
      name: '',
      src: '',
    })
  }, [state, setFormObj])

  useEffect(()=>{ //For submitting the form as soon as image state gets updated
    if(image.length>0){
      formSubmitHandler();
    }

  },[image])

  const [imageSrc, setImageSrc] = useState({
    name: '',
    src: '',
    styles:{
      badgeTitle:'',
      badgeDifficulty:'',
      badgeType:''
    }
  })

  const [selectedSkeleton, setSelectedSkeleton] = useState("Select a skeleton")
  // const imagePicker = useRef() // For upload from client side
  const clear = (e) => {
    e.preventDefault()
    setFormObj((data) => ({
      ...data,
      state: 'idle',
      title: '',
      version: '',
      issuedBy: '',
      authorizedBy: '',
      description: { counter: 0, value: '', status: '', maxCount: 250 },
      skills: { counter: 0, value: '', status: '', maxCount: 250 },
      type: 'Select type of the badge',
      level: 'Select level of the badge',
      time: '',
      expirationYears: '',
      criteria: '',
      image: [],
    }))
  }

  // const onImageChange = (event) => { //For upload from client side
  //   event.preventDefault()
  //   if (event.target.files) {
  //     console.log(event.target.files);
  //     // setFormObj((data) => ({ ...data, image: [...event.target.files] }))

  //     let reader = new FileReader()
  //     setImageSrc((data) => ({
  //       ...data,
  //       name: event.target.files[0].name,
  //     }))
  //     reader.onload = (e) => {
  //       setImageSrc((data) => ({
  //         ...data,
  //         src: e.target.result,
  //       }))
  //     }
  //     reader.readAsDataURL(event.target.files[0])
  //   }
  // }

  function toDataUrl(url, callback) { //Fetches skeleton badge
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  const skeletonPicker =(e)=>{ //Converts url to base64 so as to get captured by html2canvas; html2canvas cannot capture image loaded with url
    setSelectedSkeleton(e.target.value);
    let skeleton=skeletonBadges.find(elem=>elem.name===e.target.value)
    
    toDataUrl(skeleton.link, function(myBase64) {
      setImageSrc((data) => ({
        ...data,
        src: myBase64,
        ...skeleton
      })); // myBase64 is the base64 string
    });
  }

  function DataURIToBlob(dataURI) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
  }

  const submit = (e) => {
    e.preventDefault()
    let imageContainer = document.getElementById("image-render-div")
    html2canvas(imageContainer).then(function(canvas) {
    
      let base64 = canvas.toDataURL('image/png', 1.0);
      let imgTag = document.createElement('img')
      imgTag.src=base64;
      let blob = DataURIToBlob(base64)
      var file = new File([blob], "demo.PNG",{
        type:"image/png"
      });
      setFormObj((data) => ({ ...data, image: [file] }))
    });
  }

  return (
    <form onSubmit={submit}>
      <div className='row'>
        <div className='col-md-4  mt-3 mt-md-2'>
          <TextInput
            itemKey={title}
            name='title'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Title'
            placeholder='Enter title of the badge'
          />
        </div>
        <div className='col-md-4  mt-3 mt-md-2'>
          <TextInput
            itemKey={version}
            name='version'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Version'
            placeholder='Enter version of the badge'
          />
        </div>
        <div className='col-md-4  mt-3 mt-md-2'>
          <TextInput
            itemKey={issuedBy}
            name='issuedBy'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Issued By'
            placeholder='Enter issuer of the badge'
          />
        </div>
      </div>
      <div className='row mt-3'>
        <div className='col-md-4 mt-2'>
          <TextInput
            itemKey={authorizedBy}
            name='authorizedBy'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Authorized By'
            placeholder='Enter authoriser of the badge'
          />
        </div>
        <div className='col-md-4 mt-3 mt-md-2'>
          <SelectInput
            name='type'
            state={type}
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Type'
            placeholder='Select type of the badge'
            options={['Completion', 'Certification']}
          />
        </div>
        <div className='col-md-4 mt-3 mt-md-2'>
          <SelectInput
            name='level'
            state={level}
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Level'
            placeholder='Select level of the badge'
            options={['foundational', 'intermediate', 'advance']}
          />
        </div>
      </div>
      <div className='row mt-3'>
        <div className='col-md-4 m mt-2 mt-md-2'>
          <TextInput
            type='number'
            itemKey={expirationYears}
            name='expirationYears'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Expiration in Years'
            placeholder='Enter expiration of the badge'
          />
        </div>
        <div className='col-md-4  mt-3 mt-md-2'>
          <TextInput
            itemKey={time}
            name='time'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Time'
            placeholder='Time in days/hours eg: 2 days or 12 hours'
          />
        </div>
        <div className='col-md-4  mt-3 mt-md-2'>
          <TextInput
            itemKey={criteria}
            name='criteria'
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Criteria'
            placeholder='Enter criteria for getting the badge'
          />
        </div>
      </div>
      <div className='row pe-0'>
        <div className='row pe-0 col-md-8'>
          <div className='col-md-6 pe-0 skills'>
            <TextArea
              rows={2}
              itemKey={skills}
              name='skills'
              formState={state}
              onChangeHandler={textAreaHandler}
              labelText='Skills'
              placeholder='Enter skills associated with the badge eg: Python, DS'
            />
          </div>

          <div className='col-md-6 pe-0'>
            {/* <label className='form-label mt-2 '>Select Image</label>
            <button type='button' className='imagePicker' onClick={() => imagePicker.current.click()}>
              <span>{imageSrc.name}</span>
              <i className='fas fa-cloud-upload-alt'></i>
            </button>
            <input
              ref={imagePicker}
              type='file'
              hidden
              onChange={onImageChange}
              accept='image/png, image/jpg, image/jpeg'
              className='filetype'
            /> */}
            <label htmlFor={"skeleton-picker"} className='form-label mt-2'>
              {"Select Skeleton"}<span className="text-danger">*</span>
            </label>
            <select
              className='form-select'
              id={"skeleton-picker"}
              name={"skeleton-picker"}
              disabled={state !== 'idle' }
              value={selectedSkeleton}
              onChange={skeletonPicker}>
              <option disabled hidden defaultChecked>
                {"Select a skeleton"}
              </option>
              {skeletonBadges.map((element, i) => (
                <option value={element.name} key={i}>
                  {element.name}
                </option>
              ))}
            </select>
          </div>

          <div className='col-md-12 mt-2 pe-0 description'>
            <TextArea
              itemKey={description}
              name='description'
              formState={state}
              onChangeHandler={textAreaHandler}
              labelText='Description'
              placeholder='Enter description of the badge'
            />
          </div>
        </div>
        {imageSrc.src !== '' && (
          <div className='col-md-4 ms-2 '>
            <label className='form-label mt-2'>Badge Preview</label>
            <div id='image-renderer' className='p-2 d-flex justify-content-center align-items-center'>
              <div id='image-render-div'>
              <img id="image-renderer-img" src={imageSrc.src} alt='' />
              <span className="badge-title" style={imageSrc.styles.badgeTitle}>{title+" "+version}</span>
              <span className="badge-difficulty" style={imageSrc.styles.badgeDifficulty}>
                {level==="foundational" ? <i className="fas fa-star"></i> : level==="intermediate" ? <><i className="fas fa-star"></i><i className="fas fa-star"></i></> :level==="advance"? <><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i></>:<></>}
              </span>
              <span className="badge-type" style={imageSrc.styles.badgeType}>{type!=="Select type of the badge" && type}</span>
              </div>
            </div>
           
          </div>
        )}
      </div>

      <div className='row'>
        <div className='col-md-6 d-flex justify-content-start mt-3 mb-2'>
          <button className='btn btn-light px-4 py-2 my-4 me-3' onClick={clear}>
            Clear
          </button>
          <button
            className={`btn btn-${state === 'submitted' ? 'success' : 'badge'} my-4`}
            disabled={state !== 'idle'}
            type='submit'>
            {state === 'submitting' && <div id='loading'></div>}
            {state === 'idle' && (
              <span>
                <i className='far fa-check-circle me-2'></i>Create Badge
              </span>
            )}
            {state === 'submitted' && 'Badge Created Successfully'}
          </button>
        </div>
      </div>
      </form>
    
  )
}

export default Form
